import { z } from 'zod';
import { configOverridesSchema } from '#schemas/config-override/config-overrides-schema.ts';

export const advancedFormPartSchema = z.object({
  configOverrides: configOverridesSchema,
});
